<div class="formly-field-wrap signature-field">
  @if(!isReadonly()) {
    <div class="signature-canvas-container" [class.error]="formControl.invalid">
      <canvas 
        #signatureCanvas 
        class="signature-canvas"
        [class.has-signature]="hasSignature()">
      </canvas>
      
      @if(!hasSignature()) {
        <div class="signature-placeholder">
          <app-dynamic-icon name="brush"></app-dynamic-icon>
          <p>{{ 'FORM.SIGNATURE.SIGN_HERE' | translate }}</p>
        </div>
      }
    </div>

    <div class="signature-actions">
      <input 
        #fileInput
        type="file" 
        accept="image/*" 
        style="display: none"
        (change)="onFileSelect($event)">
      
      <ion-button 
        fill="outline"
        (click)="fileInput.click()">
        <app-dynamic-icon slot="start" name="image" size="large" class="button-icon"></app-dynamic-icon>
        {{ 'FORM.SIGNATURE.UPLOAD_IMAGE' | translate }}
      </ion-button>

      @if(hasSignature()) {
        <ion-button 
          fill="outline"
          color="danger"
          (click)="clearSignature()">
          <app-dynamic-icon slot="start" name="trash" size="large" class="button-icon"></app-dynamic-icon>
          {{ 'FORM.SIGNATURE.CLEAR' | translate }}
        </ion-button>
      }
    </div>

  } @else {
    <div class="signature-readonly">
      @if(hasSignature()) {
        <canvas 
          #readonlyCanvas 
          class="signature-image"
          style="width: 100%; height: 200px;">
        </canvas>
      } @else {
        <div class="no-signature">
          {{ 'FORM.SIGNATURE.NO_SIGNATURE' | translate }}
        </div>
      }
    </div>
  }
  
  <ng-template #fieldComponent></ng-template>
</div>
